// extracted by mini-css-extract-plugin
module.exports = {"dropdownItemSpacer":"OpsNotifications_dropdownItemSpacer__eYji_","loadingSpinner":"OpsNotifications_loadingSpinner__2jemX"};